<template>
	<drawer
			title="Pay statements"
			@updateClose="onClose"
			@updateSave="onSave"
	>
		<field
				margin="0 0 10px 0"
				width="300px"
				label="Customer"
				:setInputValue="paidData.customer"
				is-readonly
		></field>
		<field
				margin="0 0 10px 0"
				width="300px"
				label="Driver"
				:setInputValue="paidData.driver"
				is-readonly
		></field>
		<field
				:class-error="$v.amount && $v.amount.$error"
				margin="0 0 10px 0"
				width="300px"
				label="Amount"
				placeholder="Select amount"
				type="number"
				:setInputValue="amount"
				@updateInput="onInput($event, 'amount')"
				is-required
		></field>
		<field
				margin="0 0 10px 0"
				width="300px"
				label="Note"
				placeholder="Enter text"
				:setInputValue="notes"
				@updateInput="onInput($event, 'notes')"
				is-textarea
		></field>
	</drawer>
</template>

<script>
import { mapActions } from "vuex";
// shared
// validate
import { minValue, required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import Drawer from "@/shared/Drawer/Drawer.vue";

export default {
	mixins: [ validationMixin ],
	name: "DrawerDriverStatements",
	components: {
		Drawer,
	},
	props: {
		paidData: Object
	},
	data: () => ({
		customer: null,
		driver: null,
		notes: '',
		amount: 0,
		preloader: false
	}),
	validations: {
		amount: { required, minValue: minValue(0.1) },
	},
	methods: {
		...mapActions([ 'onDriverStatementsSetPay' ]),
		onClose() {
			this.$emit('updateClose');
		},
		onInput({ value }, key) {
			this[key] = value;
		},
		async onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				this.preloader = true;
				const { notes: note, amount } = this.$data;
				await this.onDriverStatementsSetPay({ note, paid_amount: +amount, id: this.paidData.id });
				this.onClose();
				this.preloader = false;
			}
		}
	}
};
</script>

